module.exports = __webpack_public_path__ + "static/media/Model-Buttons-Center.a21a2ca7.svg";